import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

export default class DetailHeader extends Component {
  render(){
    let columnClass = 'col-4';
    let warningMsg = this.props.onlyHeader ? {border: '0px'} : {border: '0px', borderTop: '1px solid #dbdee0'};
    if (this.props.col4Title) { columnClass='col-3'; }
    return(
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h4 className="hidden-xs-down m-0">{this.props.title}</h4><h5 className="hidden-sm-up m-0">{this.props.title}</h5>
          {this.props.hideAction ?
            null
          :
            <div className="text-right">
              {this.props.action2Available ?
                <span onClick={this.props.action2} className={this.props.action2Class}>
                  <i className={this.props.action2IconClass}></i>
                  {this.props.action2Title}
                </span>
              :
                null
              }
              <span onClick={this.props.action} className={this.props.actionClass}>
                <i className={this.props.actionIconClass}></i>
                {this.props.actionTitle}
              </span>
            </div>
          }
        </div>
        {!this.props.onlyHeader ?
          <div className="card-block">
            <div className="row">
              <div className={columnClass}>
                <h6>{this.props.col1Title}</h6>
                {this.props.col1Link ?
                  <NavLink to={this.props.col1Link}>
                    {this.props.col1Desc}
                  </NavLink>
                :
                  <div>{this.props.col1Desc}</div>
                }

              </div>
              <div className={columnClass}>
                <h6>{this.props.col2Title}</h6>
                {this.props.col2Link ?
                  <NavLink to={this.props.col2Link}>
                    {this.props.col2Desc}
                  </NavLink>
                :
                  <div>{this.props.col2Desc}</div>
                }
              </div>
              <div className={columnClass}>
                <h6>{this.props.col3Title}</h6>
                <div>{this.props.col3Desc}</div>
              </div>
              {this.props.col4Title ?
                <div className={columnClass}>
                  <h6>{this.props.col4Title}</h6>
                  <div>{this.props.col4Desc}</div>
                </div> : null}
            </div>
          </div>
        :
          null
        }
        {this.props.appendWarningMessage ?
          <div className="card card-header mb-0" style={warningMsg}>
            <span>
              <i className="fa fa-exclamation-triangle mr-05 color-yellow"></i>
              {this.props.warningMessage}
            </span>
          </div>
        : null
        }
      </div>
    );
  }
}
